import * as React from "react";
import { Auth, Hub } from "aws-amplify";
import protectedRoute from "./protectedRoute";
import ChangeNewPassword from "./components/accountManagement/ChangePassword";
import ConfirmPassword from "./components/accountManagement/ConfirmPassword";
import ErrorPage from "./components/other/ErrorPage";
import HomeBar from "./HomeBar";
import { useLocation } from "react-router-dom";

const initialFormState = {
  username: "",
  oldPassword: "",
  newPassword: "",
};

let currentCognitoUser = "";
let currentLogInUser = "";

async function changePassword({ oldPassword, newPassword }, updateFormType) {
  try {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        return Auth.changePassword(user, oldPassword, newPassword);
      })
      .then((data) => {
        updateFormType("confirmPassword");
      })
      .catch((err) => {
        updateFormType("errorPage");
      });
  } catch (err) {}
}

function Protected(props) {
  let location = useLocation();
  const [change, setChange] = React.useState(false);
  const [currentUser, setUser] = React.useState(null);
  const [formType, updateFormType] = React.useState("changePassword");
  const [formState, updateFormState] = React.useState(initialFormState);

  React.useEffect(() => {
    checkUser();
    Hub.listen("auth", (data) => {
      const { payload } = data;
      if (payload.event === "signOut") {
        setUser(null);
      }
    });
  }, []);

  React.useEffect(() => {
    if (true == change && null != location.state) {
      updateFormType(location.state.formType);
    }
  }, [location.state]);

  React.useEffect(() => {
    if ("changePassword" != formType) {
      setChange(true);
      location.state = null;
    }
  }, [formType]);

  async function checkUser() {
    try {
      const data = await Auth.currentUserPoolUser();
      const session = data.getSignInUserSession();
      const userInfo = { username: data.username, ...data.attributes };
      currentLogInUser = userInfo;
      if (session) {
        currentCognitoUser = data;
      } else {
      }
      setUser(userInfo);
    } catch (err) {}
  }

  function updateForm(event) {
    const newFormState = {
      ...formState,
      [event.target.name]: event.target.value,
    };
    updateFormState(newFormState);
  }

  function renderForm() {
    switch (formType) {
      case "changePassword":
        return (
          <ChangeNewPassword
            changePassword={() => changePassword(formState, updateFormType)}
            updateFormState={(e) => updateForm(e)}
          />
        );
      case "confirmPassword": {
        return <ConfirmPassword />;
      }
      case "errorPage": {
        return <ErrorPage />;
      }
      default:
        return null;
    }
  }

  return (
    <div>
      <HomeBar />
      {renderForm()}
    </div>
  );
}

export default protectedRoute(Protected);
